/* OKKO B2B — pagina prodotto: galleria (replica UX Maximize B2C: thumbs
 * verticali, frecce, lightbox "enlarge" con contatore e tastiera), cambio
 * variante (prezzo/SKU/stock/foto) e ATC AJAX su /cart/add.js.
 * Badge stock da window.OKKO.ui.stockBadge, pill da window.OKKO.updateCartCount,
 * testi da window.OKKO.testi con fallback. Caricato SOLO sul template product. */
(() => {
  'use strict';

  const embed = document.querySelector('[data-okko-pdp-varianti]');
  if (!embed) return;

  const T = (window.OKKO && window.OKKO.testi) || {};
  const varianti = JSON.parse(embed.textContent);
  const immaginiEmbed = document.querySelector('[data-okko-pdp-immagini]');
  const immagini = immaginiEmbed ? JSON.parse(immaginiEmbed.textContent) : [];
  const sel = document.querySelector('[data-okko-pdp-select]');
  const qty = document.querySelector('[data-okko-pdp-qty]');
  const atc = document.querySelector('[data-okko-pdp-atc]');
  const errore = document.querySelector('[data-okko-pdp-errore]');

  // --- Lista varianti: celle colonna dalla thead -----------------------------
  // Le colonne sono blocchi ANNIDATI (blocks/col-*.liquid) e Liquid non puo'
  // iterarli per riga: i figli rendono solo le <th>. Qui montiamo le celle di
  // ogni riga leggendo thead + JSON varianti, PRIMA del restoreDraft di
  // DOMContentLoaded (script defer in ordine). Metafield: valore a livello
  // prodotto, copiato da data-okko-valore della th.

  function montaColonne() {
    document.querySelectorAll('[data-okko-vtab]').forEach((wrap) => {
      const cols = [...wrap.querySelectorAll('thead th[data-okko-col]')];
      wrap.querySelectorAll('tbody [data-okko-line]').forEach((tr) => {
        tr.querySelectorAll('td[data-okko-cella]').forEach((td) => td.remove());
        const v = varianti.find((x) => x.id === Number(tr.dataset.variantId));
        if (!v) return;
        cols.forEach((th) => {
          const td = document.createElement('td');
          td.dataset.okkoCella = '';
          // stessa ancora del catalogo (data-okko-colonna): sul mobile la riga
          // diventa card col CSS gia' esistente delle liste
          td.dataset.okkoColonna = th.dataset.okkoCol;
          switch (th.dataset.okkoCol) {
            case 'sku':
              td.className = 'okko-cell-sku';
              td.textContent = v.sku || '';
              break;
            case 'stock':
              td.innerHTML = window.OKKO.ui ? window.OKKO.ui.stockBadge(v.disp ? v.m : 0, v.pre) : '';
              break;
            case 'prezzo':
              td.className = 'is-num';
              td.innerHTML = window.OKKO.ui ? prezzoBss(v) : '';
              break;
            case 'qta': {
              td.className = 'is-qty';
              // Confezione (multiplo d'ordine, dal metafield prodotto via embed): stesso
              // contratto di okko-qty-input — step=N, data-okko-confezione, max al piu'
              // grande multiplo nello stock, "—" se lo stock non copre una confezione.
              // Il resto (clamp morbido, snap sul change, stepper) e' delegato a okko-cart.js.
              const cf = v.cf > 1 ? v.cf : 0;
              const maxV = cf && typeof v.m === 'number' ? Math.floor(v.m / cf) * cf : v.m;
              const ordinabile = v.disp && !(cf && typeof maxV === 'number' && maxV === 0);
              const hint = cf ? ` title="${(T.confezioneDa || 'Confezione da %N% pz').replace('%N%', cf)}"` : '';
              // esaurita (non "sotto confezione": li' lo stock c'e' e l'avviso
              // mentirebbe): bottone Avvisami dal template condiviso
              td.innerHTML = ordinabile
                ? `<div class="okko-qty"><button type="button" data-okko-qty-step="-1" aria-label="Diminuisci" tabindex="-1">−</button><input class="okko-qty-cell" data-okko-qty type="number" inputmode="numeric" min="0" step="${cf || 1}"${cf ? ` data-okko-confezione="${cf}"` : ''}${hint} value="0"${typeof maxV === 'number' ? ` max="${maxV}"` : ''} aria-label="Quantità"><button type="button" data-okko-qty-step="1" aria-label="Aumenta" tabindex="-1">+</button></div>`
                : (!v.disp && window.OKKO.bisBottone && window.OKKO.bisBottone(v.id)) || '<span aria-hidden="true">—</span>';
              break;
            }
            case 'subtotale':
              td.className = 'is-num';
              td.setAttribute('data-okko-subtotal', '');
              td.innerHTML = '&mdash;';
              break;
            case 'metafield':
              td.className = 'okko-cell-mf';
              td.textContent = th.dataset.okkoValore || '';
              break;
          }
          tr.appendChild(td);
        });
      });
    });
    if (window.OKKO.restoreDraft) window.OKKO.restoreDraft();
    if (window.OKKO.paintBis) window.OKKO.paintBis(); // stato "gia' chiesto" sui bottoni appena montati
  }
  montaColonne();
  // editor del tema: la sezione si ri-renderizza, le celle vanno rimontate
  document.addEventListener('shopify:section:load', montaColonne);
  // prezzi personalizzati BSS: il ponte carica async DOPO questo montaggio; quando
  // e' pronto, rimontiamo (prezzoBss ora ha i prezzi scontati) e riapplichiamo il
  // prezzo principale.
  document.addEventListener('okko:bss:pronto', () => { montaColonne(); if (typeof applica === 'function') applica(); });

  // --- Galleria --------------------------------------------------------------

  const galleria = document.querySelector('[data-okko-galleria]');
  const zoom = galleria ? galleria.dataset.zoom : 'enlarge';
  let indice = 0;

  function vai(i) {
    if (!immagini.length) return;
    indice = ((i % immagini.length) + immagini.length) % immagini.length;
    const img = document.querySelector('[data-okko-pdp-foto] img');
    if (img) {
      img.src = immagini[indice];
      img.removeAttribute('srcset');
    }
    document.querySelectorAll('[data-okko-pdp-thumb]').forEach((t) => {
      const attiva = Number(t.dataset.okkoPdpThumb) === indice;
      t.classList.toggle('is-attiva', attiva);
      if (attiva) t.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
    document.querySelectorAll('[data-okko-pdp-dot]').forEach((d) => {
      d.classList.toggle('is-attiva', Number(d.dataset.okkoPdpDot) === indice);
    });
    const contatore = document.querySelector('[data-okko-pdp-contatore]');
    if (contatore) contatore.textContent = `${indice + 1} / ${immagini.length}`;
  }

  // Lightbox: quella CONDIVISA del tema (window.OKKO.lightbox, okko-cart.js) —
  // le frecce/tastiera sono sue; onNav risincronizza la galleria sotto.
  function apriLightbox() {
    if (!window.OKKO || !window.OKKO.lightbox || !immagini.length) return;
    window.OKKO.lightbox(immagini.map((src) => ({ full: src })), indice, (i) => vai(i));
  }

  // Lente d'ingrandimento (zoom "magnifier"): l'origine segue il mouse
  if (zoom === 'magnifier') {
    document.addEventListener('mousemove', (e) => {
      const foto = e.target.closest('[data-okko-pdp-foto]');
      if (!foto) return;
      const img = foto.querySelector('img');
      if (!img) return;
      const r = foto.getBoundingClientRect();
      img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
    });
  }

  // --- Variante --------------------------------------------------------------

  const corrente = () => {
    const id = sel ? Number(sel.value) : varianti[0].id;
    return varianti.find((x) => x.id === id) || varianti[0];
  };

  // Prezzo personalizzato BSS (se il ponte lo ha per questa variante): pieno
  // barrato + scontato. Gemello di renderCell del ponte; fallback = prezzo base.
  function prezzoBss(v) {
    const bss = window.OKKO && window.OKKO.bss;
    const sc = bss && bss.prezzoVariante ? bss.prezzoVariante(v.id) : null;
    return sc ? window.OKKO.ui.prezzoHtml(sc.p, v.cap, sc.op) : window.OKKO.ui.prezzoHtml(v.p, v.cap);
  }

  function applica() {
    const v = corrente();
    const prezzo = document.querySelector('[data-okko-pdp-prezzo]');
    if (prezzo && window.OKKO.ui) prezzo.innerHTML = prezzoBss(v);
    const sku = document.querySelector('[data-okko-pdp-sku]');
    if (sku) sku.textContent = v.sku || '';
    const stock = document.querySelector('[data-okko-pdp-stock]');
    if (stock && window.OKKO.ui) stock.innerHTML = window.OKKO.ui.stockBadge(v.disp ? v.m : 0, v.pre);
    if (atc) atc.disabled = !v.disp;
    if (typeof v.img === 'number') vai(v.img);
    if (errore) errore.hidden = true;
  }

  document.addEventListener('change', (e) => {
    if (sel && e.target === sel) applica();
    // Fine digitazione sulla quantita' PDP: aggancio alla confezione (minimo una).
    if (qty && e.target === qty) {
      const conf = Number(qty.dataset.okkoConfezione) || 0;
      if (conf && window.OKKO.clampQty) {
        qty.value = String(Math.max(conf, window.OKKO.clampQty(qty.value, qty.max, conf)));
      }
    }
  });

  // --- Interazioni -----------------------------------------------------------

  document.addEventListener('click', async (e) => {
    const thumb = e.target.closest('[data-okko-pdp-thumb]');
    if (thumb) {
      vai(Number(thumb.dataset.okkoPdpThumb));
      return;
    }

    const freccia = e.target.closest('[data-okko-pdp-freccia]');
    if (freccia) {
      vai(indice + Number(freccia.dataset.okkoPdpFreccia));
      return;
    }

    const dot = e.target.closest('[data-okko-pdp-dot]');
    if (dot) {
      vai(Number(dot.dataset.okkoPdpDot));
      return;
    }

    // layout griglia: clic su una cella = lightbox da quell'immagine
    const cella = e.target.closest('[data-okko-pdp-grid]');
    if (cella) {
      if (zoom === 'none' || !immagini.length) return;
      indice = Number(cella.dataset.okkoPdpGrid) || 0;
      apriLightbox();
      return;
    }

    // zoom "enlarge": clic sulla lente O sulla foto stessa
    if (e.target.closest('[data-okko-pdp-zoom]') || (e.target.closest('[data-okko-pdp-foto]') && e.target.tagName === 'IMG')) {
      if (zoom !== 'enlarge' || !immagini.length) return;
      apriLightbox();
      return;
    }

    const step = e.target.closest('[data-okko-pdp-step]');
    if (step && qty) {
      // Confezione (multiplo d'ordine): il click avanza di N e riaggancia al multiplo;
      // qui il minimo e' SEMPRE una unita'/confezione (dalla PDP si compra, non si azzera).
      const conf = Number(qty.dataset.okkoConfezione) || 0;
      const inc = conf || (window.OKKO.passo ? window.OKKO.passo() : 1);
      const raw = (Number(qty.value) || 0) + Number(step.dataset.okkoPdpStep) * inc;
      const q = window.OKKO.clampQty ? window.OKKO.clampQty(raw, qty.max, conf) : raw;
      qty.value = String(Math.max(conf || 1, q));
      return;
    }

    if (e.target.closest('[data-okko-pdp-atc]')) {
      const v = corrente();
      // Cintura e bretelle: anche se il change non e' scattato, all'ATC la quantita'
      // si riaggancia alla confezione (mai sotto una, mai oltre lo stock).
      const conf = Number(qty && qty.dataset.okkoConfezione) || 0;
      let n = Math.max(1, Number(qty && qty.value) || 1);
      if (conf && window.OKKO.clampQty) {
        n = Math.max(conf, window.OKKO.clampQty(n, qty.max, conf));
        qty.value = String(n);
      }
      atc.disabled = true;
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: n }),
      });
      if (res.ok) {
        const cart = await (await fetch('/cart.js')).json();
        if (window.OKKO.updateCartCount) window.OKKO.updateCartCount(cart);
        atc.dataset.state = 'added';
        atc.textContent = T.aggiunto || 'Aggiunto ✓';
        setTimeout(() => {
          delete atc.dataset.state;
          atc.textContent = T.aggiungiCarrello || 'Aggiungi al carrello';
          atc.disabled = !corrente().disp;
        }, 1600);
      } else {
        // trappola nota: /cart/add.js e' atomico e il 422 non spiega — messaggio unico
        atc.disabled = false;
        if (errore) {
          errore.textContent = T.nonDisponibile || 'Quantità non disponibile per questa variante.';
          errore.hidden = false;
        }
      }
    }
  });
})();
